import React from 'react';

import styled from 'styled-components';

import { Link } from 'gatsby';

export const NavHeaderDiv = styled.div`
  background-color: transparent;
  color: white;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 46px;
  text-align: center;
  line-height: 46px;

  @media(max-width: 720px) {
    display: none;
  }
`;

export const NavHeaderButton = styled(({ currentPage, ...props }) => <Link {...props} />)`
  opacity: ${(props) => (props.currentPage ? 1 : 0.6)};
  color: ${(props) => (props.currentPage ? 'var(--color-accent)' : 'inherit')};

  font-size: 18px;
  text-decoration: none;
  transition: 0.2s all ease-in-out;
  margin: 12px;

  
  &:hover {
    color: var(--color-accent);
    opacity: 1;
    cursor: pointer;
  }
`;

export const NavFooterDiv = styled.div`
  background-color: #222222;
  color: white;
  width: 100%;
  height: 50px;
  transition: 0.2s all ease-in-out;
  text-align: center;
  /* line-height: 50px; */
`;

export const NavButton = styled(Link)`
  color: white;
  font-size: 16px;
  
  opacity: 0.6;
  text-decoration: none;
  transition: 0.3s all ease-in-out;
  margin: 20px;
  &:hover {
    color: var(--color-accent);
    opacity: 1;
    cursor: pointer;
  }
`;

export const TopNav = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: transparent;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1101;
  top: 0;
  width: 100vw;
  height: 46px;
  transition: 0.2s top ease-in-out, 0.32s background-color ease-in-out;
`

export const SideMenu =  styled.div`
  .logo-button {
    text-decoration: none;
    color: white;
    line-height: 46px;
    margin-left: 1.5em;
    /* Hidden when at top */
    pointer-events: none;
    opacity: 0;
    transition: 0.2s opacity ease-in-out;
  }

  /* Individual item */
  .bm-item {
    display: inline-block;
    /* Our sidebar item styling */
    text-decoration: none;
    font-size: 30px;
    margin-bottom: 10px;
    color: inherit;
    transition: 0.1s all ease-in-out !important;
  }
  /* Change color on hover */
  .bm-item:hover {
    color: var(--color-accent);
  }
  /* The rest copied directly from react-burger-menu docs */
  /* Position and sizing of burger button */
  .bm-burger-button {
    background: none;
    position: fixed;
    width: 25px;
    height: 20px;
    right: 1em;
    top: 12.5px;
  }
  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: #FFFFFF;
    border-radius: 20px;
    pointer-events: none;
    transition: 0.2s all ease-in-out;
  }
  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }
  /* Color/shape of close button cross */
  .bm-cross {
    background: #bdc3c7;
    pointer-events: none;
  }
  /* General sidebar styles */
  .bm-menu {
    background: #292929;
    padding: 2.5em 1.5em 0;
    font-size: 1.15em;
    overflow-y: hidden !important;
  }
  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #292929;
  }
  /* Wrapper for item list */
  .bm-item-list {
    color: #b8b7ad;
  }
  /* Styling of overlay */
  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
  }
  @media(min-width: 721px) {
    display: none;
  }
`
// breadcrumbs located 
export const BreadcrumbContainer = styled.div`
  // Applied to the breadcrumb title (<span>)
  .breadcrumb__title {
    color: white;
    text-decoration: none;
  }

  // Applied to the breadcrumb container (<nav>)
  .breadcrumb {
    font-size: var(--font-small-size);
    font-weight: 600;
  }

  // Applied to each breadcrumb ‘crumbs’ (<li>)
  .breadcrumb__list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding-left: 0;
  }

  // Applied to each breadcrumb ‘crumbs’ (<li>)
  .breadcrumb__list__item {
    margin: 0 0.25em;
  }

  // Applied to the link of the breadcrumb (<a>)
  .breadcrumb__link {
    text-decoration: none;
  }

  // Added to the current link (<a>)
  .breadcrumb__link__active {
    text-decoration: none;
    color: var(--color-accent) !important;

  }

  // link that is not current
  .breadcrumb__link__disabled {
    text-decoration: none;
  }

  // Applied to the breadcrumb separators (<span>)
  .breadcrumb__separator {
    white-space: nowrap;
    display: inline-block;
    padding: 0 5px;
    color: var(--color-light-gray) !important;
  }
`;
